import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "transmissionFilled"
const TransmissionFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 1.5C21.157 1.5 22.5 2.843 22.5 4.5 22.5 5.898 21.544 7.072 20.25 7.406V10.5C20.25 11.743 19.243 12.75 18 12.75H12.75V16.595C14.044 16.927 15 18.102 15 19.5 15 21.157 13.657 22.5 12 22.5S9 21.157 9 19.5C9 18.102 9.956 16.927 11.25 16.595V12.75H5.25V16.595C6.544 16.927 7.5 18.102 7.5 19.5 7.5 21.157 6.157 22.5 4.5 22.5S1.5 21.157 1.5 19.5C1.5 18.102 2.456 16.927 3.75 16.595V7.405C2.456 7.073 1.5 5.899 1.5 4.5 1.5 2.843 2.843 1.5 4.5 1.5S7.5 2.843 7.5 4.5C7.5 5.846 6.613 6.985 5.392 7.365Q5.322 7.387 5.25 7.405V11.25H11.25V7.406C9.956 7.072 9 5.898 9 4.5 9 2.843 10.343 1.5 12 1.5S15 2.843 15 4.5C15 5.898 14.044 7.072 12.75 7.406V11.25H18C18.414 11.25 18.75 10.914 18.75 10.5V7.406C17.456 7.072 16.5 5.898 16.5 4.5 16.5 2.843 17.843 1.5 19.5 1.5" />
        </svg>
      }
    </span>
  )
}
export default TransmissionFilledIcon
